import {IForm} from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'deptName',
      type: 'select',
      label: '岗位',
      placeholder: '请选择岗位',
      filterable: true,
      options: [
        {title: '全部', value: ''},
        {title: '518', value: '518'},
        {title: '投教', value: '投教'}
      ]
    },
    {
      field: 'groupId',
      type: 'select',
      label: '组',
      placeholder: '请选择组',
      filterable: true,
      clearable: true,
      options: []
    },
    {
      field: 'timeSlot',
      type: 'datepicker',
      label: '筛选日期',
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        type: 'daterange',
        'value-format': 'YYYY-MM-DD',
        disabledDate: (date: Date) => {
          return new Date() < date
        }
      }
    }
  ]
}
